import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/qwe.jpg';
import UTrackerImg from '../images/utracker.jpg';
import GreenCtgImg from '../images/greenctg.jpg';
import CoinTrackerImg from '../images/cointracker.jpg';
import CavinImg from '../images/cavinimg.jpg';
import TrueGre from '../images/truegre.jpg';
import PrositeImg from '../images/prosite.png';
import GeoImg from '../images/Geo_att.jpg';
import VideoImg from '../images/VideoRes.png';

const projects = [
  {
    id: uuidv4(),
    name: 'PROSITE - Uni Final year Project',
    desc:
      'Our final year university project was a mobile application designed by the four of us. It serves as an online platform for finding hardware and labor services, accessible through a user-friendly mobile interface.',
    img: PrositeImg,
    github: 'https://github.com/ProSiteGroup2',
  },
  {
    id: uuidv4(),
    name: 'Covid19 Data Tracker',
    desc:
      'Using this Web app you can track Covid-19 stat in Sri Lanka and Worldwide situation.',
    img: CoinTrackerImg,
  },
  {
    id: uuidv4(),
    name: 'Travel Web Site',
    desc:
      'A website of a traveling guide in SriLanka. It gives information about what the offer in South Asia.',
    img: GreenCtgImg,
  },
  {
    id: uuidv4(),
    name: 'Upper Deck',
    desc:
      'Developed a website that features blog posts aimed at helping restaurant owners and managers improve their businesses as well as students and trainees in the hospitality industry.The blog posts cover a wide range of topics and offer practical advice and tips.',
    img: GeoImg,
  },
  {
    id: uuidv4(),
    name: 'Weather Web App',
    desc:
      'A Web application to get Climate details on specific areas on worldwide.',
    img: UTrackerImg,
  },

  {
    id: uuidv4(),
    name: 'Geo Attendance Mobile App',
    desc:
      'This application allows users to easily mark their attendance and view their previous attendance records.he app utilizes geolocation codes to accurately track a users location and records their in and out times along with the date.',
    img: GeoImg,
  },
  {
    id: uuidv4(),
    name: "Vihan's Portfolio",
    desc:
      'A full informatics portfolio of mine. The portfolio is made using ReactJs and GatsbyJs.',
    img: CavinImg,
  },
  {
    id: uuidv4(),
    name: 'Travel Mobile App',
    desc:
      'A mobile App for travelers in Sri Lanka to get information about traveling areas. And it suggesting some new things to them',
    img: ProjectImg,
  },
  {
    id: uuidv4(),
    name: 'Global Warming Web Site',
    desc:
      'A website about Global warming. It gives information about awareness of global warming.',
    img: TrueGre,
  },
  {
    id: uuidv4(),
    name: 'Video Reservation System',
    desc:
      'This CRUD web application is an application that allows users to create, read, update, and delete video reservations. It can be used by businesses and individuals to manage their video library, and can also be used to lend and reserve videos for future purposes.',
    img: VideoImg,
  },
  {
    id: uuidv4(),
    name: 'Library Management System',
    desc:
      'This is a Library management system developed as a mini-project using Java and Netbeans IDE✨. This System manages all the processes in a book store.',
    img: TrueGre,
  },
];

export default projects;
